import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/analytics/topic-discovery/$topicDiscoveryId')({});
